import { DateTime } from 'luxon';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { type Appointment } from '../../types/appointments.types';
import {
  AppointmentContainer,
  AppointmentDateAndTime,
  AppointmentTitle,
  CalendarContainer,
} from './appointment-item.styled';

interface AppointmentProps {
  appointment: Appointment;
  showServices?: boolean;
}

export function AppointmentItem({ appointment }: AppointmentProps) {
  const { t } = useTranslation();

  if (!appointment) {
    return null;
  }

  return (
    <AppointmentContainer>
      <CalendarContainer>
        <span>{DateTime.fromISO(appointment.date).toFormat('d')}</span>
        <span>{DateTime.fromISO(appointment.date).toFormat('MMM')}</span>
      </CalendarContainer>
      <AppointmentTitle>Appointment for {appointment.pet?.name}</AppointmentTitle>
      <AppointmentDateAndTime>
        {DateTime.fromISO(appointment.date)
          .plus({ seconds: appointment.time || 0 })
          .toFormat('EEE d MMM yyyy - h:mm a')}
        {' at '}
        {appointment.workplace?.name}
      </AppointmentDateAndTime>
    </AppointmentContainer>
  );
}
